define('view/controller/booking/datetime/classes/TimeClassesProviderColumnView',['require','marionette','view/controller/booking/datetime/classes/TimeClassesProviderItemView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var TimeClassesProviderItemView = require('view/controller/booking/datetime/classes/TimeClassesProviderItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Classes provider column view
     *
     * @class TimeClassesProviderColumnView
     */
    return Marionette.CompositeView.extend({

        childView: TimeClassesProviderItemView,
        childViewContainer: '.sb_time_classes_provider_column',
        template: '#time_classes_provider_column_view',
        childViewOptions: function (model) {
            var from = new Time(model.get('from'));
            var to = new Time(model.get('to'));

            return {
                'provider': this._providerModel,
                'top': (100 / this._slotsCount) * ((from.getInteger() - this._timeFrom.getInteger()) / this._timeFrame),
                'height': (100 / this._slotsCount) * ((to.getInteger() - from.getInteger()) / this._timeFrame)
            };
        },
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        _slotsCount: 0,
        _timeFrom: new Time(),
        _timeTo: new Time(),
        _timeFrame: 5,
        _providerModel: null,

        initialize: function () {
            this._slotsCount = this.getOption('slotsCount');
            this._timeFrom = this.getOption('timeFrom');
            this._timeTo = this.getOption('timeTo');
            this._timeFrame = this.getOption('timeFrame');

            this._providerModel = this.getOption('providerModel');
        }

    });

});
